import api from '@/plugins/axios';

export interface CmsErrorReport {
  /** What the editor was doing, e.g. "factcheck-aanmaken". */
  action: string;
  /** The step that failed, in the words the editor sees. */
  step: string;
  message: string;
  context: Record<string, string>;
}

interface ApiErrorBody {
  message?: string;
}

interface ErrorWithDetails {
  message?: string;
  code?: string;
  response?: { status?: number; data?: ApiErrorBody };
  config?: { method?: string; url?: string };
}

/** A readable reason for any error the CMS gets: API (axios), Firebase or plain Error. */
export const describeError = (error: unknown): string => {
  if (typeof error === 'string') return error;
  if (!error || typeof error !== 'object') return 'onbekende fout';
  const e = error as ErrorWithDetails;
  if (e.response) {
    const request = e.config ? `${(e.config.method || '').toUpperCase()} ${e.config.url || ''}`.trim() : '';
    const reason = e.response.data?.message || e.message || '';
    return [request, e.response.status, reason].filter(Boolean).join(' – ');
  }
  return [e.code, e.message].filter(Boolean).join(' – ') || 'onbekende fout';
}

/** Sends a failure to the API, which writes it to the Cloud Run log as "[cms-error]". Never throws. */
export const ReportCmsError = async (report: CmsErrorReport): Promise<void> => {
  try {
    await api.post('/errors/cms', report);
  } catch (reportError) {
    console.error('Could not report the error', reportError);
  }
}
